<template>
    <router-link :to="homeURL()" id="logo">
        <img src="@/assets/img/ui/logo.svg">
    </router-link>
</template>
<script>
export default {
    data() {
        return {
            globalData: undefined,
        };
    },
    mounted() {
        this.globalData = app.api.PageManager.getCustomComponentFromType('globalData');
    },
    methods: {
        homeURL() {
            if (app.api.PageManager.onHomePage() && this.overviewURL)
                return app.api.PageManager.getRootPage().route + ":" + this.overviewURL;
            else
                return app.api.PageManager.getRootPage().route;
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for randomly timed animations
            return Math.random() * (max - min) + min;
        },
    },
    computed: {
        overviewURL() {
            if (this.globalData?.data?.overviewContent)
                return app.api.PageManager.getContentComponentFromID(this.globalData?.data?.overviewContent).slug
        },
        // getContinuousAnimation() {
        //     this.$route;
        //     if (app.api.PageManager.onHomePage() && this.overviewURL)
        //         return {
        //             'animation-name': "loopPulse",
        //             'animation-iteration-count': 'infinite',
        //             'animation-duration': '1s',
        //             'animation-delay': this.getRandomAnimationDelay(2, 14).toFixed(1) + 's'
        //         }
        // }
    }
}
</script>
<style lang="scss">
#logo {
    position: absolute;
    top: 50px;
    left: var(--page-margin);
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 300px;
    width: 330px;



    z-index: 2;
    cursor: pointer;
    transition: background-color 0.2s ease-in-out;

    &>img {
        width: 100%;
        // height: 50px;
    }

    &::before {
        transition: scale .3s ease-in-out;
        content: '';
        width: calc(100% + 60px);
        height: calc(100%);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        // background-color: rgba(0, 0, 0, .5);
        opacity: .5;
        border-radius: 15px;
        z-index: -1;
        // background-color: radial-;
        // background: radial-gradient(rgba(0, 0, 0, .3), #ffffff00 60%, #ffffff00);
        background: transparent radial-gradient(closest-side at 50% 50%, #00000054 0%, #00000000 100%) 0% 0% no-repeat padding-box;
    }
}

/* pulse animation */
@keyframes loopPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
        transform: scale(1.1);
    }

    7% {
        box-shadow: 0 0 0 120px rgba(255, 255, 255, 0);
        transform: scale(1.02);
    }

    10% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }
}
</style>